import { render, staticRenderFns } from "./ExportLoadRegistrationForm.vue?vue&type=template&id=6a6b4626&scoped=true&"
import script from "./ExportLoadRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./ExportLoadRegistrationForm.vue?vue&type=script&lang=js&"
import style0 from "./ExportLoadRegistrationForm.vue?vue&type=style&index=0&id=6a6b4626&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6b4626",
  null
  
)

export default component.exports